// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"686":"35d2768d98d9662a","5811":"e4f0819816dc9911","9836":"880a333e1ba1b066"}[chunkId] + ".js";
};